// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.experience-main {
  width: 100%;
}

.basic-experience {
  margin-left: 5%;
  margin-right: 5%;
}

.experience-heading-div {
  display: flex;
}

.experience-heading-div > * {
  flex: 1 1;
}

.experience-heading-img-div {
  align-items: center;
  justify-content: center;
}

.experience-heading-text-div {
  text-align: center;
}

.experience-heading-img-div > * {
  max-width: 100%;
  height: auto;
}

.experience-heading-text {
  font-size: 56px;
  font-weight: 400;
  font-family: "Google Sans Medium";
  line-height: 1.1;
  text-align: center;
  margin-top: 80px;
}

.experience-heading-sub-text {
  font-size: 30px;
  font-family: "Google Sans Regular";
  text-align: center;
  margin-bottom: 10px;
}

.experience-header-detail-text {
  font-size: 20px;
  line-height: 30px;
  margin-top: 0px;
  margin-left: 20px;
  margin-right: 20px;
  font-family: "Google Sans Medium";
}

@media (max-width: 1380px) {
  .experience-heading-text {
    font-size: 50px;
    margin-top: 80px;
  }
  .experience-heading-sub-text {
    font-size: 25px;
  }
}

@media (max-width: 768px) {
  .experience-heading-text {
    font-size: 30px;
    margin-top: 20px;
  }

  .experience-heading-sub-text {
    font-size: 20px;
  }

  .experience-heading-div {
    flex-direction: column;
  }

  .experience-header-detail-text {
    font-size: 16px;
    margin-right: 0px;
    line-height: normal;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/experience/Experience.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".experience-main {\n  width: 100%;\n}\n\n.basic-experience {\n  margin-left: 5%;\n  margin-right: 5%;\n}\n\n.experience-heading-div {\n  display: flex;\n}\n\n.experience-heading-div > * {\n  flex: 1;\n}\n\n.experience-heading-img-div {\n  align-items: center;\n  justify-content: center;\n}\n\n.experience-heading-text-div {\n  text-align: center;\n}\n\n.experience-heading-img-div > * {\n  max-width: 100%;\n  height: auto;\n}\n\n.experience-heading-text {\n  font-size: 56px;\n  font-weight: 400;\n  font-family: \"Google Sans Medium\";\n  line-height: 1.1;\n  text-align: center;\n  margin-top: 80px;\n}\n\n.experience-heading-sub-text {\n  font-size: 30px;\n  font-family: \"Google Sans Regular\";\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.experience-header-detail-text {\n  font-size: 20px;\n  line-height: 30px;\n  margin-top: 0px;\n  margin-left: 20px;\n  margin-right: 20px;\n  font-family: \"Google Sans Medium\";\n}\n\n@media (max-width: 1380px) {\n  .experience-heading-text {\n    font-size: 50px;\n    margin-top: 80px;\n  }\n  .experience-heading-sub-text {\n    font-size: 25px;\n  }\n}\n\n@media (max-width: 768px) {\n  .experience-heading-text {\n    font-size: 30px;\n    margin-top: 20px;\n  }\n\n  .experience-heading-sub-text {\n    font-size: 20px;\n  }\n\n  .experience-heading-div {\n    flex-direction: column;\n  }\n\n  .experience-header-detail-text {\n    font-size: 16px;\n    margin-right: 0px;\n    line-height: normal;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
